// Localização: frontend/src/components/UI/ToastNotification.jsx
// Componente de notificação toast reutilizável

import React from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';
import { useNotification } from '../../context/NotificationContext';

/**
 * Componente ToastNotification
 * Exibe notificações toast no canto da tela
 */
const ToastNotification = () => {
    const { notifications, removeNotification } = useNotification();

    return (
        <>
            {/* Notificações Toast Ativas */}
            {notifications.length > 0 && (
                <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-3 max-w-md w-full sm:w-auto px-4 sm:px-0">
                    {notifications.map(notification => (
                        <ToastItem
                            key={notification.id}
                            notification={notification}
                            onClose={() => removeNotification(notification.id)}
                        />
                    ))}
                </div>
            )}
        </>
    );
};

/**
 * Item individual de toast
 */
const ToastItem = ({ notification, onClose }) => {
    const { message, type } = notification;

    // Define estilos e ícones baseados no tipo
    let classes = {};
    let IconComponent = Info;

    switch (type) {
        case 'success':
            classes = {
                container: 'bg-white border-l-4 border-green-500 shadow-lg',
                icon: 'text-green-500',
                message: 'text-gray-800',
                button: 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
            };
            IconComponent = CheckCircle;
            break;
        case 'error':
            classes = {
                container: 'bg-white border-l-4 border-red-500 shadow-lg',
                icon: 'text-red-500',
                message: 'text-gray-800',
                button: 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
            };
            IconComponent = XCircle;
            break;
        case 'warning':
            classes = {
                container: 'bg-white border-l-4 border-yellow-500 shadow-lg',
                icon: 'text-yellow-500',
                message: 'text-gray-800',
                button: 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
            };
            IconComponent = AlertTriangle;
            break;
        case 'info':
        default:
            classes = {
                container: 'bg-white border-l-4 border-blue-500 shadow-lg',
                icon: 'text-blue-500',
                message: 'text-gray-800',
                button: 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
            };
            IconComponent = Info;
            break;
    }

    return (
        <div
            className={`${classes.container} rounded-lg p-4 flex items-start gap-3 animate-slide-in-right w-full sm:min-w-[300px] sm:max-w-md`}
            role="alert"
        >
            {/* Ícone */}
            <IconComponent className={`w-5 h-5 ${classes.icon} flex-shrink-0 mt-0.5`} />

            {/* Mensagem */}
            <div className="flex-1">
                <p className={`text-sm font-medium ${classes.message}`}>{message}</p>
            </div>

            {/* Botão de Fechar */}
            <button
                onClick={onClose}
                className={`${classes.button} p-1 rounded-full transition-colors flex-shrink-0`}
                aria-label="Fechar notificação"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
};

export default ToastNotification;

